(() => {
  const selectors = {
    mobileToggle: "[data-mobile-toggle]",
    mobileClose: "[data-mobile-close]",
    mobileMenu: "[data-mobile-menu]",
    toast: "[data-nexa-toast]",
    cartCount: "[data-cart-count]"
  };

  const routes = window.NexaRoutes || {};

  function showToast(message) {
    const toast = document.querySelector(selectors.toast);
    if (!toast) return;

    toast.textContent = message;
    toast.classList.add("is-visible");

    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => {
      toast.classList.remove("is-visible");
    }, 3000);
  }

  async function refreshCartCount() {
    if (!routes.cartGet) return;

    try {
      const response = await fetch(routes.cartGet, {
        headers: { Accept: "application/json" }
      });
      if (!response.ok) return;

      const cart = await response.json();
      document.querySelectorAll(selectors.cartCount).forEach((node) => {
        node.textContent = cart.item_count;
      });
    } catch (error) {
      console.warn("Nexa cart count refresh failed:", error);
    }
  }

  function initMobileMenu() {
    document.addEventListener("click", (event) => {
      if (event.target.closest(selectors.mobileToggle)) {
        document.body.classList.add("mobile-menu-open");
      }

      if (event.target.closest(selectors.mobileClose)) {
        document.body.classList.remove("mobile-menu-open");
      }

      const menu = event.target.closest(selectors.mobileMenu);
      if (menu && event.target === menu) {
        document.body.classList.remove("mobile-menu-open");
      }
    });
  }

  function initAjaxAddToCart() {
    document.addEventListener("submit", async (event) => {
      const form = event.target.closest(".nexa-quick-add, .nexa-product-form, .nexa-sticky-form");
      if (!form || !routes.ajaxCart) return;

      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const originalText = button ? button.textContent : "";

      if (button) {
        button.disabled = true;
        button.textContent = "Adding...";
      }

      try {
        const response = await fetch(routes.cartAdd, {
          method: "POST",
          body: new FormData(form),
          headers: { Accept: "application/json" }
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || "Could not add item.");
        }

        await refreshCartCount();
        showToast(`${data.product_title || "Item"} added to cart.`);
      } catch (error) {
        showToast(error.message || "Something went sideways. The cart gremlin is being dramatic.");
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      }
    });
  }

  function initProductStickySync() {
    const variantSelect = document.querySelector("[data-product-variant-select]");
    const stickyVariant = document.querySelector("[data-sticky-variant-id]");
    const quantityInput = document.querySelector("[data-product-quantity]");
    const stickyQuantity = document.querySelector("[data-sticky-quantity]");

    if (variantSelect && stickyVariant) {
      variantSelect.addEventListener("change", () => {
        stickyVariant.value = variantSelect.value;
      });
    }

    if (quantityInput && stickyQuantity) {
      quantityInput.addEventListener("input", () => {
        stickyQuantity.value = quantityInput.value || 1;
      });
    }
  }

  function initQuiz() {
    document.querySelectorAll("[data-nexa-quiz]").forEach((quiz) => {
      const answers = {};
      const resultWrap = quiz.querySelector("[data-quiz-result]");
      const resultCards = quiz.querySelectorAll("[data-quiz-result-card]");

      function showResult() {
        const counts = {};

        Object.values(answers).forEach((key) => {
          counts[key] = (counts[key] || 0) + 1;
        });

        const winner = Object.keys(counts).sort((a, b) => counts[b] - counts[a])[0];

        resultCards.forEach((card) => {
          card.hidden = card.dataset.resultKey !== winner;
        });

        if (resultWrap) {
          resultWrap.hidden = false;
          resultWrap.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }

      quiz.addEventListener("click", (event) => {
        const option = event.target.closest("[data-quiz-option]");
        const reset = event.target.closest("[data-quiz-reset]");

        if (reset) {
          Object.keys(answers).forEach((key) => delete answers[key]);
          quiz.querySelectorAll("[data-quiz-option]").forEach((node) => node.classList.remove("is-selected"));
          if (resultWrap) resultWrap.hidden = true;
          resultCards.forEach((card) => (card.hidden = true));
          return;
        }

        if (!option) return;

        const question = option.dataset.question;
        answers[question] = option.dataset.result;

        quiz.querySelectorAll(`[data-quiz-option][data-question="${question}"]`).forEach((node) => {
          node.classList.remove("is-selected");
        });

        option.classList.add("is-selected");

        if (Object.keys(answers).length >= 3) {
          showResult();
        }
      });
    });
  }

  function initSliders() {
    document.querySelectorAll("[data-nexa-slider]").forEach((slider) => {
      const slides = Array.from(slider.querySelectorAll("[data-slide]"));
      const prev = slider.querySelector("[data-slider-prev]");
      const next = slider.querySelector("[data-slider-next]");
      const configNode = slider.querySelector("[data-slider-config]");
      let active = 0;
      let config = { autoplay: false, interval: 5000 };

      if (configNode) {
        try {
          config = JSON.parse(configNode.textContent);
        } catch (error) {
          console.warn("Nexa slider config invalid:", error);
        }
      }

      function go(index) {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle("is-active", slideIndex === active);
        });
      }

      if (prev) prev.addEventListener("click", () => go(active - 1));
      if (next) next.addEventListener("click", () => go(active + 1));

      if (config.autoplay && slides.length > 1) {
        window.setInterval(() => go(active + 1), Number(config.interval) || 5000);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initMobileMenu();
    initAjaxAddToCart();
    initProductStickySync();
    initQuiz();
    initSliders();
  });

  document.addEventListener("shopify:section:load", () => {
    initQuiz();
    initSliders();
  });
})();
